<template>
    <v-ons-page>
        <div class="center" style="height: 100%;">
            <img :src="closeImage" class="imageClose" @click="pop()"/>
            <img :class="{rotateImage: rotate,hidde : visible}" id="imagefullScreen" class="fullScreen" :src="image"/>
            <PinchImage :rotate="rotate" :src="image" :min-zoom="1" :max-zoom="2.5"></PinchImage>
        </div>
    </v-ons-page>
</template>

<script>
    import TopBar from '../components/TopBar'
    import PinchImage from '../components/PinchImage'

    export default {
        name: 'image',
        components: {
            PinchImage,
        },
        data: function () {
            return {
                closeImage: require('../assets/img/UI/Recurso 33.png'),
                onsNavigatorOptions: {
                    animation: 'none'
                },
                rotate: false,
                visible: false,
            }
        }, methods: {
            pop() {
                this.$emit('pop');
            }
        },
        props: [
            'image'
        ],
        mounted() {
            const width = document.getElementById('imagefullScreen').clientWidth;
            const height = document.getElementById('imagefullScreen').clientHeight;
            if (width > height) {
                this.rotate = true;
            }
            this.visible = true;
            console.log(width);
            console.log(height);
            console.log(this.rotate);
            document.getElementById('imagefullScreen').display = "none";
        }

    }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .center {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .rotateImage {
        transform: rotate(90deg);
        max-width: 145vw !important;
    }

    .imageClose {
        top: 3%;
        position: absolute;
        left: 90vw;
        border-radius: 50%;
        background-color: black;
        padding: 5px;
        opacity: 0.7;
        z-index: 999;
        height: 5vw;
    }

    .fullScreen {
        max-width: 100%;
        max-height: 100%;
    }

    .hidde {
        display: none;
    }

</style>



// WEBPACK FOOTER //
// src/pages/ImagePage.vue